<template lang="pug">
section
  ErrorMessage
  ConfiguratorHeader
    
  .configurator__grid
    SelectorConnector(:parameter="'connector_left'")
    SelectorCable(:parameter="'cable'")
    SelectorConnector(:parameter="'connector_right'")

  ConfiguratorFooter

</template>

<script>
// @ is an alias to /src
import ErrorMessage from "@/components/configurator/ErrorMessage";
import ConfiguratorHeader from "@/components/configurator/ConfiguratorHeader";
import SelectorConnector from "@/components/configurator/SelectorConnector";
import SelectorCable from "@/components/configurator/SelectorCable";
import ConfiguratorFooter from "@/components/configurator/ConfiguratorFooter";


export default {
  name: "Configurator",
  components: {
    ConfiguratorHeader,
    ConfiguratorFooter,
    SelectorConnector,
    SelectorCable,
    ErrorMessage
  },
};
</script>


<style lang="scss" scoped>
section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: clamp(1.125rem, 3vw, 2rem);
  background: $white;
  box-shadow: 0 0 0.5rem rgba($black, 0.0375), 0 0 1rem rgba($black, 0.02);
}

.configurator__grid {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 1fr 1fr;
  gap: clamp(0.3875rem, 2vw, 1rem);
  position: relative;
}
</style>